module.exports = __webpack_public_path__ + "img/Cookie_1_resize_16.820a481c.png";